import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import {
  watchdogDeleteMany,
  watchdogLoadAll,
  watchdogSendNow,
} from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(watchdogLoadAll.type, send, socket);
  yield takeEvery(watchdogDeleteMany.type, send, socket);
  yield takeEvery(watchdogSendNow.type, send, socket);
}
